import { IModel, Model } from '@common/models/Model';
import { observable } from 'mobx';

export interface IScheduleJobModel extends IModel {
  hangFireKey: string;
  name: string;
  enabled: boolean;
  configurationKey: string;
  configurationValue: string;
  endpointSuffix: string;
}

export class ScheduleJobModel extends Model implements IScheduleJobModel {
  hangFireKey: string;
  name: string;
  enabled: boolean;
  configurationKey: string;
  @observable configurationValue: string;
  endpointSuffix: string;

  constructor(params: Partial<IScheduleJobModel>) {
    super();
    this.hangFireKey = _.defaultTo(params.hangFireKey, '');
    this.name = _.defaultTo(params.name, '');
    this.enabled = _.defaultTo(params.enabled, false);
    this.configurationKey = _.defaultTo(params.configurationKey, '');
    this.configurationValue = _.defaultTo(params.configurationValue, '');
    this.endpointSuffix = _.defaultTo(params.endpointSuffix, '');
  }
}

export interface IScheduleJobModelForm {
  scheduledJobs: IScheduleJobModel[];
}
